import { FuelSkeleton } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import React from 'react';
import { Card } from '../Card';

export const Skeleton = () => (
  <>
    <Card testId="skeleton-item-one">
      <FuelFlex defaultProps={{ display: 'flex', flexDirection: 'column', gap: 'km1' }}>
        <FuelSkeleton shape="pill" size="custom" width="140px" height="24px" />
        <FuelSkeleton shape="pill" size="custom" width="130px" height="24px" />
      </FuelFlex>
      <FuelFlex
        defaultProps={{
          display: 'flex',
          flexDirection: 'row',
          gap: 'km4',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <FuelSkeleton shape="pill" size="custom" width="110px" height="24px" />
        <FuelSkeleton shape="pill" size="custom" width="100px" height="24px" />
      </FuelFlex>
    </Card>
    <Card testId="skeleton-item-two">
      <FuelFlex defaultProps={{ display: 'flex', flexDirection: 'column', gap: 'km1' }}>
        <FuelSkeleton shape="pill" size="custom" width="140px" height="24px" />
        <FuelSkeleton shape="pill" size="custom" width="130px" height="24px" />
      </FuelFlex>
      <FuelFlex
        defaultProps={{
          display: 'flex',
          flexDirection: 'row',
          gap: 'km4',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <FuelSkeleton shape="pill" size="custom" width="110px" height="24px" />
        <FuelSkeleton shape="pill" size="custom" width="100px" height="24px" />
      </FuelFlex>
    </Card>
    <Card testId="skeleton-item-three">
      <FuelFlex defaultProps={{ display: 'flex', flexDirection: 'column', gap: 'km1' }}>
        <FuelSkeleton shape="pill" size="custom" width="140px" height="24px" />
        <FuelSkeleton shape="pill" size="custom" width="130px" height="24px" />
      </FuelFlex>
      <FuelFlex
        defaultProps={{
          display: 'flex',
          flexDirection: 'row',
          gap: 'km4',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <FuelSkeleton shape="pill" size="custom" width="110px" height="24px" />
        <FuelSkeleton shape="pill" size="custom" width="100px" height="24px" />
      </FuelFlex>
    </Card>
  </>
);
